import React, { useState, useCallback, useEffect } from "react";
import Grid from "@material-ui/core/Grid";
import {
  StyledAttachmentContainer,
  StyledAttachmentFieldSet,
  StyledAttachmentImg,
  StyledAttachmentLegend,
  StyledButton,
  StyledCloseButton,
  StyledCloseicon,
  StyledComponent,
  StyledContainerWrapper,
  StyledInquiryWrapper,
  StyledMessage,
  StyledSelectContainer,
  StyledSelects,
  StyledSubmitButton,
  StyledText,
  StyledTextWrapper,
  StyledValidationMessages,
  StyledWrapper,
} from "./InquiryDetailsCss";
import {
  TextareaAutosize,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
} from "@material-ui/core";
import { enquiryPostdata } from "../../../../common/config/app.endpoints";
import AuthService from "../../../auth/AuthService";
import { StyledModal } from "../../../../common/materials/GenericStyleComponent";
import ConfirmationPopup from "./ConfirmationPopup";
import { oAuth } from "../../../../routes/basic/BasicAppRouter";
import IRouterComponentProps from "../../../../models/IRouterComponentProps";
import { useDropzone } from "react-dropzone";
import styled from "styled-components";
import Alert from "../../../../common/elements/Alert";

interface IProps extends IRouterComponentProps {
  t?: any;
  closeModal: () => void;
  saveQuery: () => void;
}

export const StyledApp = styled.img`
  cursor: pointer;
  width: 1.5em;
  height: 1.5em;
`;

let acceptedFileItems: any;
var downloadIndex = 0;
let fileNames: any = "";

const GenInquiry = (props: any) => {
  const { t, closeModal } = props;
  const Auth = new AuthService();
  const [description, setDescription] = useState("");
  // const [fileToUpload, setFileToUpload] = useState('');
  const [companyLogo, setCompanyLogo] = useState("");
  const [section, setSection] = useState("");
  const [confirmationPopUp, setConfirmationPopUp] = useState(false);

  const [openToast, setOpenToast] = useState(false);

  const [showMessage, setShowMessage] = useState("");
  const [alertType, setAlertType] = useState("");
  const [message, setMessage] = useState("");
  const [submitButtonDisable, setSubmitButtonDisable] = useState(false);
  const [fileName, setFileNames] = useState("");
  const { getRootProps, getInputProps, acceptedFiles } = useDropzone({
    accept: "image/png, image/gif, image/jpeg, image/jpg",
    maxSize: 5,
  });

  useEffect(() => {
    setOpenToast(false);
    setFileNames("");
  }, []);

  const handleChange = async (e: any) => {
    const targeName = e.target.name;
    const targeValue = e.target.value;

    if (targeName === "description") {
      setDescription(targeValue);
    }
    if (targeName === "section") {
      setSection(targeValue);
    }

    if (targeName === "companyLogo") {
      if (e.target.files[0] !== undefined && e.target.files[0] !== "") {
        let fileObj = e.target;
        let isMediaTypeImage: boolean = await getFileExt(fileObj);

        if (isMediaTypeImage) {
          if (getFileSize(fileObj.files[0])) {
            setCompanyLogo(fileObj.files);
            setSubmitButtonDisable(false);

            acceptedFileItems = fileObj.files;
            for (let i = 0; i < acceptedFileItems.length; i++) {
              let file = acceptedFileItems.item(i);
              let filesName = file.name;
              let fileLength = acceptedFileItems.length - 1;
              setFileNames(
                `${filesName} ${fileLength === 0 ? "" : `+ ${fileLength}`}`
              );
            }
          } else {
            setCompanyLogo("");
            setAlertType("error");
            setShowMessage(`File size should be less than 5 MB.`);
            setOpenToast(true);
          }
        } else {
          setCompanyLogo("");
          setAlertType("error");
          setShowMessage(`File should be image.`);
          setOpenToast(true);
        }
        setTimeout(() => {
          setOpenToast(false);
        }, 3000);
      }
    }
  };

  const getFileSize = (file: any) => {
    const fsize = file.size;
    const fileSize = Math.round(fsize / 1024);
    if (fileSize > 5000) {
      return false;
    } else {
      return true;
    }
  };

  const getFileExt = (image: any) => {
    const fileInput = image;
    const filePath = fileInput.value;

    const allowedExtensions: any = /(\.jpg|\.jpeg|\.png|\.gif)$/i;

    if (!allowedExtensions.test(filePath)) {
      return false;
    } else {
      return true;
    }
  };

  const formSubmit = async (e: any) => {
    e.preventDefault();
    var formData = new FormData();

    if (description.trim() === "" && section.trim() === "") {
      setMessage(
        `${t("common:allValidations:emptyFields")}` + `: - Query and section`
      );
    } else if (description.trim() === "") {
      setMessage("Please enter any Query.");
    } else if (section.trim() === "") {
      setMessage("Please select your Query section.");
    } else {
      let apiform = {
        description: description,
        section: section,
      };
      var test = JSON.stringify(apiform);
      formData.append("enquiry", test);
      if (companyLogo !== "") {
        for (let i = 0; i < companyLogo.length; i++) {
          if (companyLogo.length <= 5) {
            formData.append("fileToUpload", companyLogo[i]);
          } else {
            setAlertType("error");
            setShowMessage("Attachment should be less than 5 MB.");
            setOpenToast(true);
          }
        }
      } else {
        formData.append("fileToUpload", companyLogo);
      }
      if (
        description.trim() !== "" &&
        section.trim() !== "" &&
        companyLogo.length <= 5
      ) {
        callAPI(formData);
      } else {
        //
      }
    }
  };
  const callAPI = (formData: any) => {
    setSubmitButtonDisable(true);
    if (!oAuth()) {
      props.history.push("/");
    } else {
      Auth.inquiryPostRequest(
        `${enquiryPostdata}`,
        formData,
        (status: number, response: any) => {
          if (status === 200) {
            props.saveQuery();
            setConfirmationPopUp(true);
            acceptedFileItems = "";
            setFileNames("");
          } else if (status > 200 && status < 500) {
            alert("invalidRequest");
            setAlertType("error");
            setOpenToast(true);
            setShowMessage("invalidRequest");
            acceptedFileItems = "";
            setFileNames("");
          }
        }
      );
    }
  };

  const handleClosePopup = () => {
    setConfirmationPopUp(false);
    closeModal(false);
    setFileNames("");
  };

  return (
    <StyledComponent>
      <form noValidate={true} name="" onSubmit={formSubmit}>
        <StyledContainerWrapper>
          <StyledWrapper container spacing={0}>
            <StyledMessage container spacing={0}>
              <Grid item xs={11}>
                {/* Submit your Query */}
                {t("common:inquiry:submitQueriy")}
              </Grid>
              <Grid>
                <StyledCloseButton onClick={closeModal}>
                  <StyledCloseicon src="/images/close-button2.ico"></StyledCloseicon>
                </StyledCloseButton>
              </Grid>
            </StyledMessage>
            <StyledText item xs={12}>
              {t("common:inquiry:submitDescription")}
            </StyledText>
            <Grid item={true} xs={12} style={{ marginBottom: "10px" }}>
              <StyledValidationMessages>{message}</StyledValidationMessages>
            </Grid>
            <StyledInquiryWrapper item md={12} xs={12} lg={6}>
              <StyledTextWrapper>
                <TextareaAutosize
                  id="description"
                  aria-label="miximum width"
                  maxLength={500}
                  required
                  rowsMin={3}
                  placeholder={t("common:inquiry:placeYourQuery")}
                  style={{ width: "90%", height: "160px" }}
                  name="description"
                  onChange={handleChange}
                />
              </StyledTextWrapper>
            </StyledInquiryWrapper>
            <StyledInquiryWrapper item md={12} xs={12} lg={6}>
              <StyledAttachmentFieldSet>
                <StyledAttachmentLegend>
                  {t("common:inquiry:fields:Section")}
                </StyledAttachmentLegend>
                <StyledSelectContainer>
                  <StyledSelects>
                    <FormControl variant="outlined" className="" fullWidth>
                      <InputLabel id="demo-simple-select-outlined-label">
                        ----Select Section----
                      </InputLabel>
                      <Select
                        required
                        autoFocus={true}
                        id="section"
                        name="section"
                        label="section"
                        onChange={handleChange}
                      >
                        <MenuItem value="Home">
                          {t("common:newCommanTrans:home")}
                        </MenuItem>
                        <MenuItem value="Preview">
                          {t("common:newCommanTrans:preview")}
                        </MenuItem>
                        <MenuItem value="Auction">
                          {t("common:newCommanTrans:auction")}
                        </MenuItem>
                        <MenuItem value="Watchlist">
                          {t("common:newCommanTrans:watchlist")}
                        </MenuItem>
                        <MenuItem value="Invoice">
                          {t("common:newCommanTrans:invoice")}
                        </MenuItem>
                        <MenuItem value="Profile">
                          {t("common:newCommanTrans:profile")}
                        </MenuItem>
                        <MenuItem value="Product">
                          {t("common:newCommanTrans:product")}
                        </MenuItem>
                        <MenuItem value="Other">
                          {t("common:newCommanTrans:other")}
                        </MenuItem>
                      </Select>
                    </FormControl>
                  </StyledSelects>
                </StyledSelectContainer>
              </StyledAttachmentFieldSet>
              <StyledAttachmentFieldSet>
                <StyledAttachmentLegend>
                  {t("common:inquiry:fields:Attachment")}
                </StyledAttachmentLegend>
                <StyledAttachmentContainer
                  container={true}
                  {...getRootProps({ className: "dropzone" })}
                >
                  <StyledAttachmentImg
                    item={true}
                    xs={12}
                    md={12}
                    sm={12}
                    lg={4}
                    xl={4}
                  >
                    <span>---{t("common:inquiry:fields:ChooseFile")}---</span>
                  </StyledAttachmentImg>
                  <StyledAttachmentImg
                    item={true}
                    xs={12}
                    md={12}
                    sm={12}
                    lg={8}
                    xl={8}
                  >
                    <input
                      {...getInputProps()}
                      multiple
                      accept="image/png, image/gif, image/jpeg, image/jpg"
                      className=""
                      id="com_logo"
                      type="file"
                      name="companyLogo"
                      onChange={handleChange}
                    />
                    <StyledApp src="/images/attachment.jpeg" />
                  </StyledAttachmentImg>
                </StyledAttachmentContainer>
              </StyledAttachmentFieldSet>
              {fileName}
              <StyledSubmitButton>
                {submitButtonDisable === true ? (
                  <StyledButton disabled style={{ background: "lightgray" }}>
                    {t("common:inquiry:button:submit")}
                  </StyledButton>
                ) : (
                  <StyledButton onSubmit={formSubmit}>
                    {t("common:inquiry:button:submit")}
                  </StyledButton>
                )}
              </StyledSubmitButton>
            </StyledInquiryWrapper>
          </StyledWrapper>
        </StyledContainerWrapper>
      </form>
      {confirmationPopUp === true && (
        <StyledModal open={confirmationPopUp} onClose={handleClosePopup}>
          <ConfirmationPopup t={t} {...props} closeModal={handleClosePopup} />
        </StyledModal>
      )}
      {openToast === true && (
        <Alert showAlertMessage={showMessage} alertType={alertType} />
      )}
    </StyledComponent>
  );
};

export default GenInquiry;
